<script setup lang="ts">
import {
  type ChatAttachment,
  downloadFile,
  getAttachmentLabel,
  getFileIcon,
  isImageFile,
  isVideoFile,
} from '../../chatModules'
import MatrixAttachmentMedia from './MatrixAttachmentMedia.vue'

interface Props {
  attachments: ChatAttachment[]
  messageText?: string
}

defineProps<Props>()
</script>

<template>
  <div
    v-if="attachments && attachments.length > 0"
    class="attachments-container"
  >
    <div
      v-for="attachment in attachments"
      :key="attachment.id"
      class="attachment-item"
    >
      <MatrixAttachmentMedia
        v-if="isImageFile(attachment.file, attachment.mime_type) || isVideoFile(attachment.file, attachment.mime_type)"
        :src="attachment.file"
        :poster="attachment.thumbnail"
        :alt="getAttachmentLabel(attachment, messageText)"
        :kind="isVideoFile(attachment.file, attachment.mime_type) ? 'video' : 'image'"
      />

      <div
        v-else
        class="attachment-file"
        @click="downloadFile(attachment.file, getAttachmentLabel(attachment, messageText))"
      >
        <VIcon :icon="getFileIcon(attachment.name || attachment.file)" size="24" />
        <span class="file-name">{{ getAttachmentLabel(attachment, messageText) }}</span>
      </div>
    </div>
  </div>
</template>
